import React, { useState } from 'react';

import { WpPopover, WpPopoverContent, WpPopoverToggle } from '../';

import { WpButton, WpButtonGroup } from '../../button';
import { WpCheckbox } from 'Wpds/components/checkbox';

const TooltipDocs = () => {
  const OnHover = () => (
    <>
      <h5>On Hover</h5>
      <WpButtonGroup>
        <WpPopover event="hover">
          <WpPopoverToggle>
            <WpButton variant="secondary">exit</WpButton>
          </WpPopoverToggle>
          <WpPopoverContent>exit without saving</WpPopoverContent>
        </WpPopover>
        <WpPopover event="hover">
          <WpPopoverToggle>
            <WpButton>save</WpButton>
          </WpPopoverToggle>
          <WpPopoverContent>exit and save</WpPopoverContent>
        </WpPopover>
      </WpButtonGroup>
    </>
  );

  const OnClick = () => (
    <>
      <h5>On Click</h5>
      <WpButtonGroup>
        <WpPopover event="click" initialOpen showArrow={false}>
          <WpPopoverToggle>
            <WpButton variant="secondary">exit</WpButton>
          </WpPopoverToggle>
          <WpPopoverContent>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
          </WpPopoverContent>
        </WpPopover>
        <WpPopover event="click">
          <WpPopoverToggle>
            <WpButton>save</WpButton>
          </WpPopoverToggle>
          <WpPopoverContent>exit and save</WpPopoverContent>
        </WpPopover>
      </WpButtonGroup>
    </>
  );

  const Controlled = () => {
    const [open, setIsOpen] = useState(false);

    return (
      <>
        <h5>Controlled</h5>
        <WpCheckbox id="cb" label="Open tooltip" checked={open} onChange={setIsOpen} />
        <WpPopover open={open}>
          <WpPopoverToggle>
            <WpButton variant="secondary">exit</WpButton>
          </WpPopoverToggle>
          <WpPopoverContent>exit without saving</WpPopoverContent>
        </WpPopover>
      </>
    );
  };

  return (
    <div>
      <br />
      <OnHover />
      <br />
      <br />
      <OnClick />
      <br />
      <br />
      <Controlled />
    </div>
  );
};

export default TooltipDocs;
